import { FlexColumn, FullContainer, GenericComponent } from '@gorila-shared-ui/components';
import { ASIDE_WIDTH } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  aside: React.ReactNode;
};

export function AsideLayout({ aside, children }: GenericComponent & Props) {
  const { css, theme } = useStyles();

  return (
    <>
      <FlexColumn
        classNames={css({
          width: `${ASIDE_WIDTH}px`,
          padding: theme.sizing.scale600,
          borderRight: `1px solid ${theme.colors.borderOpaque}`,
        })}
      >
        {aside}
      </FlexColumn>
      <FullContainer
        flexible
        classNames={css({
          boxSizing: 'border-box',
          flexDirection: 'column',
          padding: theme.sizing.scale600,
        })}
      >
        {children}
      </FullContainer>
    </>
  );
}
